export function submitCompleteTrackUtil(vuid, taskId, templateId, templateName, videoUrl) {
    // console.log("log in submitCompleteTrackUtil！");  
    _amberTrack("music_aigc_complete_task",[{
        EK:"appId",
        EV:'20c388c5b45e316d42605e09ddd37437'
      },
      {
        EK:"scene",
        EV:'AI_HR_MCZX'
      },
      {
        EK:"vuid",
        EV:vuid
      },
      {
        EK:"channel",
        EV:'014X031'
      },   
      {
        EK:"triggerType",
        EV:"2"
      },   
      {
        EK:"taskId",
        EV:taskId
      },   
      {
        EK:"templateId",
        EV:templateId
      },   
      {
        EK:"templateName",
        EV:templateName
      },   
      {
        EK:"videoUrl",
        EV:videoUrl
      }]); 
    // console.log("log out submitCompleteTrackUtil！");  
}
export function submitTrackUtil(vuid, taskId, templateId) {
      _amberTrack("music_aigc_submit_task",[{
        EK:"appId",
        EV:'20c388c5b45e316d42605e09ddd37437'
      },
      {
        EK:"scene",
        EV:'AI_HR_MCZX'
      },
      {
        EK:"vuid",
        EV:vuid
      },
      {
        EK:"channel",
        EV:'014X031'
      },   
      {
        EK:"triggerType",
        EV:"2"
      },   
      {
        EK:"taskId",
        EV:taskId
      },   
      {
        EK:"templateId",
        EV:templateId
      }]);
}